import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { BillingRootPath } from '@disco/utils/pricing'
import ModalDialog from 'components/ui/modal-dialog'

const ArtistVerificationSuccessModal = ({
  rootPath,
}: {
  rootPath: BillingRootPath
}): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onClick = () => {
    navigate(rootPath)
  }

  return (
    <ModalDialog
      title="Artist Plan"
      primaryAction={{
        caption: 'Close',
        onClick,
      }}
    >
      Thanks! Our team will review your submission and we’ll be in touch within
      24 hours.
    </ModalDialog>
  )
}

export default ArtistVerificationSuccessModal
